module.exports = __webpack_public_path__ + "static/media/fraissard.ef502be6.PNG";